import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-profile',
  templateUrl: './remove-profile.component.html',
  styleUrls: ['./remove-profile.component.scss']
})
export class RemoveProfileComponent {

}
